export const locale = {
  lang: 'zh1',
  data: {
    'CONFIRMACION': {
      'FELICI':'¡恭喜，您已經完成了配置過程!',
      'INDICACION':'為了使您的調查能夠在配置的日期被激活並準備應用，您必須單擊激活調查按鈕',
      'CONFIRMAR':'激活調查',
      'CERRAR-CONFIRMAR':'停用調查',
      'IND_CONFIRM_JP': '在繼續激活調查之前，需要確認之前配置的信息。',
      'BTN_CONFIRM_INFO': '確認信息',
      'IND_ESP_CONFIRM_JP':'一旦項目經理確認，我們將著手啟動調查。',
      'MOD_TIT_CONGR_CONF':'感謝您的確認',
      'MOD_ESP_CONFIRM_JP':'我們只需要項目經理的批准就可以進行調查激活。',
      'MESSAGE5':'準備進行主動調查',
      'HISTORY_ACTIVATION_1': '上次激活/停用',
      'HISTORY_ACTIVATION_2': '激活歷史:',
      'ESTATUS_SURVEY':{
        '0':'停用',
        '1':'激活',
        '2':'關閉',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>繼續激活調查',
          // 'MESSAGE2':', 在文本框中以紅色輸入文本</span>',
          'MESSAGE1':'<span> 要繼續激活調查，請在文本框中輸入紅色的文本 ',
          'MESSAGE2':'</span>',
          'SALIR': '取消',
          'VALIDAR': '確認',
          'ERRORNOMBREEMPRESA': '輸入的文本與紅色表示的文本不匹配',
          'SUCCES': '調查已激活',
          'CERRAR': '關',
          'SUCCES-DES': '調查已停用',
          'MESSAGE3':'<span> 要繼續停用調查，請在文本框中輸入紅色的文本 ',
          'MESSAGE4':'</span>',
          'MESSAGE5':'當前調查已經有結果，您確定可以將其停用嗎？',
          'MESSAGE6':'當前沒有調查',
          'BTN-ACEPTAR': '接受',
          'BTN-CANCELAR': '取消',
          'BTN-OK': '確定',
          'HORAMINIMA': '無法確認通過電子郵件的通信，發送第一封電子郵件的日期（啟動或第一次通知，視情況而定）必須晚於兩小時，\n\n如有必要，請再次設置日期'
        },
      },
      'MODAL_CONFIRMACION': {
        'TITULO': '資料確認',
        'INFO_1': '我們通知您，在繼續激活調查之前，您必須確認您的產品信息。 我們在下面提供貴公司和產品的詳細信息',
        'INFO_2': '如果信息正確，請單擊<b>確認</b>按鈕，否則，請聯繫您的項目經理進行審核',
        'TABLA': {
          'TITULOS': {
            'clave': '字段名稱',
            'valor': '當前值'
          },
          'CAMPOS': {
            'company_name': '公司名稱',
            'short_name': '簡稱',
            'publication_name': '出版物名稱',
            'company': '公司標誌',
            'certificate': '證書標識',
            'foundation_year': '基礎年',
            'fullTime_employees': '全職員工人數',
            'parcial_employees': '兼職合作者人數',
            'total_employees': '合作者總數',
            'sector': '部門',
            'sub_sector': '分界別',
            'rankig_type': '排名類型',
            'ranking_name': '排名名稱',
            'name_RH': '人力資源經理姓名',
            'email_RH': '人力資源經理的電子郵件',
            'tel_RH': '人力資源經理的電話號碼',
            'ext_RH': '人力資源經理擴展',
            'cel_RH': '人事經理手機號',
            'state': '狀態',
            'multinational_group': '跨國集團名稱',
            'country_application': '申請國家',
          }
        }
      }
    },
  }
};
